import React from "react";
import PropTypes from "prop-types";

import Email from "./Email";
import { FIELDS } from "apps/signup/util/constants";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
}

const EmailWrapper = (props) => {
	return (
		<div className="signup2017-emailOrFacebook signup2017-field-wrapper">
			<Email
				value={props.email}
				dismissSuggestion={props.dismissSuggestion}
				hasError={props.errors.email}
				success={props.success.email}
				suggestion={props.suggestions.email}
				feedback={props.feedback.email}
				onChange={props.onChange}
				validate={props.validate}
				fieldName={FIELDS.EMAIL}
				isUpdating={props.isUpdating}
			/>
		</div>
	);
};

EmailWrapper.propTypes = {
	email: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	validate: PropTypes.func.isRequired,
	dismissSuggestion: PropTypes.func.isRequired,
	isUpdating: PropTypes.bool,
	errors: PropTypes.object,
	feedback: PropTypes.object,
	suggestions: PropTypes.object,
	success: PropTypes.object,
};

EmailWrapper.defaultProps = {
	isUpdating: false,
	errors: {},
	success: {},
	feedback: {},
	suggestions: {},
};

export default EmailWrapper;



// WEBPACK FOOTER //
// ./src/apps/signup/components/Email/index.jsx